var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',{staticClass:"section__title-row"},[_c('v-col',{staticClass:"text-center"},[_c('span',{staticClass:"heading2"},[_vm._v(_vm._s(_vm.componentsData.fields.title || ""))])])],1),_vm._v(" "),_c('image-scroll-sticky',{staticClass:"section",attrs:{"items":_vm.componentsData.children,"pad-image":`${_vm.baseUrl}img/pad.svg`,"item-style":{
      left: '3.6%',
      top: '5.4%',
      width: '93%',
    },"paragraph-max-multiplier":1.5}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }